import { Component, ViewChild, ViewEncapsulation, AfterViewInit, OnInit, ElementRef } from '@angular/core';
import { TabPanel } from '@grapecity/wijmo.nav';
import { WjInputDate } from '@grapecity/wijmo.angular2.input';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW0B00Model } from './kymw0b00.model';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0B00OutputModel } from './vo/kymw0b00-output.model';
import { KYMW0B00InputModel } from './vo/kymw0b00-input.model';
import { OrderTextWithCatalogComponent } from '../../kymw02/text-input/order-text-with-catalog/order-text-with-catalog.component';
import { GetKYMW0B00InitService } from './api-services/get_kymw0B00_init.service';

/**
 * 画像検索画面を管理するクラス
 *
 * @export KYMW0B00Component
 * @class KYMW0B00Component
 */
@Component({
  selector: 'app-kymw0b00',
  templateUrl: 'kymw0b00.component.html',
  styleUrls: ['kymw0b00.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0B00Component extends PlessViewHelperSub implements OnInit, AfterViewInit {

  private readonly PANEL_TAB_INDEX_NOMAL = 0;

  /** 受渡情報 */
  private inputParam: KYMW0B00InputModel;

  // 元の画面への連携用
  public setKYMW0B00Parameter: Function;

  // 親画面からの値連携用と画面描画用
  // インスタンスは親画面で生成する
  public kymw0B00Model: KYMW0B00Model = null;

  @ViewChild('txti_StartOrderCode', { static: true }) txti_StartOrderCode: OrderTextWithCatalogComponent;
  @ViewChild('tab_KYMW0B00', { static: true }) tab_KYMW0B00: TabPanel;
  @ViewChild('dtf_ImageInstructDateStart', { static: true }) dtf_ImageInstructDateStart: WjInputDate;
  @ViewChild('dtf_ImageInstructDateEnd', { static: true }) dtf_ImageInstructDateEnd: WjInputDate;
  @ViewChild('dtf_FileRegistDateStart', { static: true }) dtf_FileRegistDateStart: WjInputDate;
  @ViewChild('dtf_FileRegistDateEnd', { static: true }) dtf_FileRegistDateEnd: WjInputDate;
  @ViewChild('dtf_PhotoScheduleStart', { static: true }) dtf_PhotoScheduleStart: WjInputDate;
  @ViewChild('dtf_PhotoScheduleEnd', { static: true }) dtf_PhotoScheduleEnd: WjInputDate;

  /**
   *Creates an instance of KYMW0B00Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0B00Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getKYMW0B00InitService: GetKYMW0B00InitService,
  ) {
    super(kymw00Model);
  }

  /**
   * @copy jp.co.toppan.pless.common.view.PlessViewHelper#init_load()
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW0B00';

    this.kymw0B00Model.processDiv = this.inputParam.processDiv;

    // コンボボックスの初期設定
    this.kymw0B00Model.initComboBoxData();

    // 画面初期表示のAPIリクエスト
    this.getKYMW0B00InitService.execute(this.kymw0B00Model);
  }

  public ngAfterViewInit(): void {
    // ngOnInit()では初期値が表示されないため、このタイミングで設定
    this.dtf_ImageInstructDateStart.text = this.kymw0B00Model.imageInstructDateStart;
    this.dtf_ImageInstructDateEnd.text = this.kymw0B00Model.imageInstructDateEnd;
    this.dtf_FileRegistDateStart.text = this.kymw0B00Model.fileRegistDateStart;
    this.dtf_FileRegistDateEnd.text = this.kymw0B00Model.fileRegistDateEnd;
    this.dtf_PhotoScheduleStart.text = this.kymw0B00Model.photoScheduleStart;
    this.dtf_PhotoScheduleEnd.text = this.kymw0B00Model.photoScheduleEnd;
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW0B00Component
   */
  public setInterfaceParam(inputVo: KYMW0B00InputModel): void {
    this.inputParam = inputVo;
    this.kymw0B00Model.c2pfSearchVisibleFlg = inputVo.c2pfSearchVisibleFlg;
  }
  /**
   * 検索ボタンを押下した時に呼び出されるメソッド。
   * @param event コールバック・イベントへの参照
   */
  public eventSearchHandler(event: Event): void {
    const outputVO: KYMW0B00OutputModel = new KYMW0B00OutputModel();

    // 通常検索タブ選択時
    if (this.tab_KYMW0B00.selectedIndex === this.PANEL_TAB_INDEX_NOMAL) {

      // 使用画像指示画面のみチェックを行う
      // 検索条件がすべて未入力であればメッセージ表示
      if (this.inputParam.processDiv === '3' && this.checkSearchCondition() === false) {
        // デフォルト表示の場合は検索条件未設定とみなす
        const showMsg = (this.kymw0B00Model.imageEnableDiv === '0') ? 'E0231' : 'E0143';
        this.dialogService.openAlertGetMessage(showMsg);
        return;
      }

      const instructDateStart: string = this.kymw0B00Model.imageInstructDateStart;
      let instructDateEnd: string = this.kymw0B00Model.imageInstructDateEnd;
      // 作成指示日(From)が未入力かつ、作成指示日(To)が入力ありの場合
      if (PlessViewUtilsSub.isEmpty(instructDateStart) && !PlessViewUtilsSub.isEmpty(instructDateEnd)) {
        this.dialogService.openAlertGetMessage('E0211', ['作成指示日']);
        return;
        // 作成指示日(From)のみ入力ありの場合
      } else if (PlessViewUtilsSub.isEmpty(instructDateEnd)) {
        instructDateEnd = instructDateStart;
        // 作成指示日で大小関係が誤りの場合：メッセージ表示
      } else if (instructDateStart > instructDateEnd) {
        this.dialogService.openAlertGetMessage('E0123', ['作成指示日']);
        return;
      }

      const registDateStart: string = this.kymw0B00Model.fileRegistDateStart;
      let registDateEnd: string = this.kymw0B00Model.fileRegistDateEnd;
      // 画像ファイル登録日(From)が未入力かつ、画像ファイル登録日To)が入力ありの場合
      if (PlessViewUtilsSub.isEmpty(registDateStart) && !PlessViewUtilsSub.isEmpty(registDateEnd)) {
        this.dialogService.openAlertGetMessage('E0211', ['画像ファイル登録日']);
        return;
        // 画像ファイル登録日(From)のみ入力ありの場合：終了日に開始日を設定
      } else if (PlessViewUtilsSub.isEmpty(registDateEnd)) {
        registDateEnd = registDateStart;
        // 画像ファイル登録日で大小関係が誤りの場合：メッセージ表示
      } else if (registDateStart > registDateEnd) {
        this.dialogService.openAlertGetMessage('E0123', ['画像ファイル登録日']);
        return;
      }

      const photoScheduleStart: string = this.kymw0B00Model.photoScheduleStart;
      let photoScheduleEnd: string = this.kymw0B00Model.photoScheduleEnd;
      // 撮影予定日(From)が未入力かつ、撮影予定日(To)が入力ありの場合
      if (PlessViewUtilsSub.isEmpty(photoScheduleStart) && !PlessViewUtilsSub.isEmpty(photoScheduleEnd)) {
        this.dialogService.openAlertGetMessage('E0211', ['撮影予定日']);
        return;
        // 撮影予定日(From)のみ入力ありの場合：終了日に開始日を設定
      } else if (PlessViewUtilsSub.isEmpty(photoScheduleEnd)) {
        photoScheduleEnd = photoScheduleStart;
        // 撮影日で大小関係が誤りの場合：メッセージ表示
      } else if (photoScheduleStart > photoScheduleEnd) {
        this.dialogService.openAlertGetMessage('E0123', ['撮影予定日']);
        return;
      }

      // 検索条件をKYMW0B00OutputVOに設定
      outputVO.pcodeList = this.kymw0B00Model.pcode;
      // 商品案内用商品名
      outputVO.guideGoodsName = this.kymw0B00Model.guideGoodsName;
      // 商品案内用規格名
      outputVO.guideStandardName = this.kymw0B00Model.guideStandardName;
      outputVO.startDelivCatalogId = this.kymw0B00Model.startDelivCatalogId;
      outputVO.startOrderCode = this.kymw0B00Model.startOrderCode;
      outputVO.classCode = this.kymw0B00Model.classCode;
      outputVO.imageName = this.kymw0B00Model.imageName;
      outputVO.imageFileName = this.kymw0B00Model.imageFileName;
      outputVO.imageBelongID = this.kymw0B00Model.imageBelongID;
      outputVO.imageKind = this.kymw0B00Model.imageKind;
      outputVO.imageType = this.kymw0B00Model.imageType;
      outputVO.processInstruct = this.kymw0B00Model.processInstruct;
      outputVO.studio = this.kymw0B00Model.studio;
      outputVO.billingName = this.kymw0B00Model.billingName;
      outputVO.buyerCode = this.kymw0B00Model.buyerCode;
      outputVO.outputFlg = this.kymw0B00Model.outputFlg;
      outputVO.c2pfStatus = this.kymw0B00Model.c2pfStatus;
      outputVO.imageUse = this.kymw0B00Model.imageUse;
      // チェック時は「1:掲載」,未チェック時は「0:未掲載を設定
      outputVO.cookingExPublish = (this.kymw0B00Model.cookingExPublish === true) ? '1' : '0';
      outputVO.carriedForward = this.kymw0B00Model.carriedForward;
      outputVO.photographingChangeSchedule = this.kymw0B00Model.photographingChangeSchedule;
      outputVO.multipleCode = this.kymw0B00Model.multipleCode;
      outputVO.c2pfTarget = this.kymw0B00Model.c2pfTarget;
      outputVO.supplierComment = this.kymw0B00Model.supplierComment;
      outputVO.remarks = PlessViewUtilsSub.trim(this.replaceAll(this.kymw0B00Model.remarks));
      outputVO.cookingDiv = this.kymw0B00Model.cookingDiv;
      outputVO.cookingName = PlessViewUtilsSub.trim(this.replaceAll(this.kymw0B00Model.cookingName));
      outputVO.materialName = PlessViewUtilsSub.trim(this.replaceAll(this.kymw0B00Model.materialName));
      outputVO.keyWord = PlessViewUtilsSub.trim(this.replaceAll(this.kymw0B00Model.keyWord));
      outputVO.eventID = this.kymw0B00Model.eventID;
      outputVO.photoContentsDiv = this.kymw0B00Model.photoContentsDiv;
      outputVO.photoStudioID = this.kymw0B00Model.photoStudio;
      if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.imageInstructUser)) {
        outputVO.imageInstructUser = this.kymw0B00Model.imageInstructUser;
      }

      // 日付 バインドされなのでModelに詰める
      outputVO.imageInstructDateStart = this.kymw0B00Model.imageInstructDateStart;
      outputVO.imageInstructDateEnd = instructDateEnd;
      outputVO.fileRegistDateStart = this.kymw0B00Model.fileRegistDateStart;
      outputVO.fileRegistDateEnd = registDateEnd;
      outputVO.photoScheduleStart = this.kymw0B00Model.photoScheduleStart;
      outputVO.photoScheduleEnd = photoScheduleEnd;

      outputVO.status = this.kymw0B00Model.imageStatus;
      if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.imageInstructDiv)) {
        outputVO.imageInstrucrDiv = this.kymw0B00Model.imageInstructDiv;
      }
      outputVO.imageEnableDiv = this.kymw0B00Model.imageEnableDiv;

      // リスト検索タブ選択時
    } else {
      // Pコードリストの必須チェック
      if (PlessViewUtilsSub.isEmpty(this.kymw0B00Model.pcodeList)) {
        this.dialogService.openAlertGetMessage('E0143');
        return;
      }

      // Pコードリストの件数チェック
      const chkResult: any = this.checkPcodeList();
      if (chkResult.cnt > 1000) {
        this.dialogService.openAlertGetMessage('E0221', ['Ｐコード', '1000']);
        return;
      }

      // 検索条件をKYMW0B00OutputVOに設定
      outputVO.pcodeList = PlessViewUtilsSub.trim(chkResult.str);
    }

    // 呼び出し元の画面に検索条件を返却する
    this.setKYMW0B00Parameter(outputVO);

    // 画面を閉じる
    this.closeFunction();

  }

  /**
   * 条件クリアボタンを押下した時に呼び出されるメソッド。
   * @param event コールバック・イベントへの参照
   */
  public eventConditionClearHandler(event: Event): void {
    // 通常検索タブ
    this.kymw0B00Model.pcode = '';
    this.kymw0B00Model.guideGoodsName = '';
    this.kymw0B00Model.guideStandardName = '';
    this.kymw0B00Model.studio = '';
    this.kymw0B00Model.imageName = '';
    this.kymw0B00Model.imageFileName = '';
    this.kymw0B00Model.classCode = '';
    this.kymw0B00Model.imageBelongID = '';
    this.kymw0B00Model.imageKind = '';
    this.kymw0B00Model.imageType = '';
    this.kymw0B00Model.processInstruct = '';
    this.kymw0B00Model.cookingExPublish = false;
    this.kymw0B00Model.remarks = '';
    this.kymw0B00Model.cookingDiv = '';
    this.kymw0B00Model.cookingName = '';
    this.kymw0B00Model.materialName = '';
    this.kymw0B00Model.keyWord = '';
    this.kymw0B00Model.eventID = '';
    this.kymw0B00Model.photoContentsDiv = '';
    this.kymw0B00Model.photoStudio = '';
    this.kymw0B00Model.imageInstructUser = '';
    this.kymw0B00Model.startDelivCatalogId = '';
    this.kymw0B00Model.startOrderCode = '';
    this.kymw0B00Model.billingName = '';
    this.kymw0B00Model.buyerCode = '';
    this.kymw0B00Model.carriedForward = false;
    this.kymw0B00Model.photographingChangeSchedule = false;
    this.kymw0B00Model.multipleCode = false;
    this.kymw0B00Model.c2pfStatus = '';
    this.kymw0B00Model.imageUse = '';
    this.kymw0B00Model.c2pfTarget = false;
    this.kymw0B00Model.supplierComment = false;

    this.eventClearImageInstructDateHandler();
    this.eventClearFileRegistDateHandler();
    this.eventClearPhotoScheduleHandler();

    this.kymw0B00Model.imageStatus = '';
    this.kymw0B00Model.imageInstructDiv = '';
    this.kymw0B00Model.imageEnableDiv = '0';
    this.kymw0B00Model.outputFlg = '';

    // リスト検索タブ
    this.kymw0B00Model.pcodeList = '';

    // 通常検索タブを表示
    this.kymw0B00Model.tabSelectIndex = this.PANEL_TAB_INDEX_NOMAL;

    // 保持している検索条件をクリア
    this.kymw0B00Model.imageInstrucrDiv = '';
  }

  /**
   * 作成指示日　クリアボタンをクリック時に呼び出されるメソッド。
   */
  public eventClearImageInstructDateHandler(): void {
    this.kymw0B00Model.imageInstructDateStart = '';
    this.kymw0B00Model.imageInstructDateEnd = '';
    this.dtf_ImageInstructDateStart.inputElement.value = '';
    this.dtf_ImageInstructDateEnd.inputElement.value = '';
  }

  /**
   * 画像ファイル登録日　クリアボタンをクリック時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventClearFileRegistDateHandler(): void {
    this.kymw0B00Model.fileRegistDateStart = '';
    this.kymw0B00Model.fileRegistDateEnd = '';
    this.dtf_FileRegistDateStart.inputElement.value = '';
    this.dtf_FileRegistDateEnd.inputElement.value = '';
  }

  /**
   * 撮影予定日　クリアボタンをクリック時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventClearPhotoScheduleHandler(): void {
    this.kymw0B00Model.photoScheduleStart = '';
    this.kymw0B00Model.photoScheduleEnd = '';
    this.dtf_PhotoScheduleStart.inputElement.value = '';
    this.dtf_PhotoScheduleEnd.inputElement.value = '';
  }

  /**
   * リスト検索タブのＰコードリストをチェック
   * 100件を超える場合はエラーメッセージを表示
   *
   * @param event コールバック・イベントへの参照
   */
  private checkPcodeList(): any {
    const ary: Array<any> = this.kymw0B00Model.pcodeList.split('\n');

    let str: string = <string>'';
    let cnt: number = <number>0;
    for (let i = Number(0); i < ary.length; i++) {
      // 空データは除外する
      if (PlessViewUtilsSub.isEmpty(ary[i])) {
        continue;
      }

      // 先頭行は改行コードを入れない
      if (cnt === 0) {
        str = ary[i];
      } else {
        str = str + ' ' + ary[i];
      }
      cnt++;
    }

    const ret: any = { cnt: cnt, str: str };
    return ret;
  }

  /**
   * 全角の空白を半角の空白に返す。
   * replace()メソッドを呼びだす。
   **/
  private replaceAll(trg: string): string {
    let returnString: string = trg;
    while (returnString.indexOf('　') > -1) {
      returnString = returnString.replace('　', ' ');
    }
    return returnString;
  }

  /**
   * 検索条件の必須チェックを行う
   * ひとつでも値があれば、trueを返す
   **/
  private checkSearchCondition(): boolean {
    // 検索条件の必須チェック
    let chkEmptyValue: boolean = <boolean>false;

    if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.pcode)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.guideGoodsName)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.guideStandardName)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.classCode)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.imageName)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.imageFileName)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.imageBelongID)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.imageKind)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.imageType)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.processInstruct)) {
      chkEmptyValue = true;
    } else if (this.kymw0B00Model.cookingExPublishSelected === true) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.remarks)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.cookingDiv)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.cookingName)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.materialName)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.keyWord)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.eventID)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.photoContentsDiv)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.photoStudio)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.imageInstructUser)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.imageInstructDateStart)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.imageInstructDateEnd)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.fileRegistDateStart)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.fileRegistDateEnd)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.imageStatus)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.imageInstructDiv)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.photoScheduleStart)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.photoScheduleEnd)) {
      chkEmptyValue = true;
    } else if (this.kymw0B00Model.carriedForward === true) {
      chkEmptyValue = true;
    } else if (this.kymw0B00Model.photographingChangeSchedule === true) {
      chkEmptyValue = true;
    } else if (this.kymw0B00Model.multipleCode === true) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.studio)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.startDelivCatalogId)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.startOrderCode)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.billingName)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.buyerCode)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.outputFlg)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.c2pfStatus)) {
      chkEmptyValue = true;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw0B00Model.imageUse)) {
      chkEmptyValue = true;
    } else if (this.kymw0B00Model.c2pfTarget === true) {
      chkEmptyValue = true;
    } else if (this.kymw0B00Model.supplierComment === true) {
      chkEmptyValue = true;
    }

    return chkEmptyValue;
  }

}
